import React, { useRef, useState } from "react"
import { PlainTextEditor } from "./PlainTextEditor"
import { Button } from "@dit/core-frontend"
import { useOnChange } from "./useOnChange"

import { CLEAR_EDITOR_COMMAND, createEditor } from "lexical"
import styles from "./styles.module.css"
import { useEditorCommentsContext } from "."
import { Box } from "@mos-cat/ds"
import { stringToEditorContent } from "@src/utils/editor"
import { MentionNode } from "../../nodes/MentionNode"

export const CommentEditComposer = ({
  commentText,
  commentId,
  commentTextBlockId,
  setIsEditComment,
  setTextContent = null,
}) => {
  const [content, setContent] = useState("")
  const [canSubmit, setCanSubmit] = useState(false)
  const editorRef = useRef(null)
  const { updateComment } = useEditorCommentsContext()
  const onChange = useOnChange(setContent, setCanSubmit)

  const submitComment = () => {
    if (canSubmit) {
      updateComment(commentId, content, commentTextBlockId)
      if (setTextContent) {
        setTextContent(content)
      }

      const editor = editorRef.current
      if (editor !== null) {
        editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined)
      }
      setIsEditComment(false)
    }
  }
  const closeEdit = () => {
    setIsEditComment(false)
  }

  const newEditor = createEditor({
    nodes: [MentionNode],
    disableEvents: false,
    editable: true,
    onError: (err) => console.error(err),
  })
  newEditor.update(() => {
    const editorState = newEditor.parseEditorState(stringToEditorContent(commentText))
    newEditor.setEditorState(editorState)
  })

  return (
    <Box position="relative">
      <PlainTextEditor
        editorState={newEditor._editorState}
        className={styles.CommentPlugin_CommentsPanel_Editor}
        autoFocus={false}
        onEscape={() => {
          return true
        }}
        onChange={onChange}
        editorRef={editorRef}
      />
      <Box display="flex" justifyContent="flex-end" gridGap="10px" margin="10px 10px">
        <Button kind="secondary" onClick={closeEdit}>
          Отменить
        </Button>
        <Button kind="primary" onClick={submitComment} disabled={!canSubmit}>
          Сохранить
        </Button>
      </Box>
    </Box>
  )
}
